/*
 * /prescription/$patientId (page)
 */
import {
	Badge,
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
	Container,
	Page,
	PageHeader,
	Placeholder,
} from "@emr/react-ui"
import { createFileRoute } from "@tanstack/react-router"
import { PrescriptionForm } from "../../features/prescription/cannabis/prescription-form"
import { trpc } from "../../trpc"
export const Route = createFileRoute("/prescription/$patientId")({
	component: PrescriptionPage,
})

function PrescriptionPage() {
	const { patientId } = Route.useParams()

	const { data: patient, isLoading: patientLoading } =
		trpc.patient.getByFilter.useQuery({ where: { id: patientId } })

	const { data: practitioner, isLoading: practitionerLoading } =
		trpc.practitioner.getByFilter.useQuery({ where: {} })

	const { data: prescription, isLoading: prescriptionLoading } =
		trpc.prescription.getByFilter.useQuery({
			where: { patientId, isLatest: true, active: true },
		})

	const { data: existingLpPrescriptions, isLoading: lpLoading } =
		trpc.lpPrescription.getAllByFilter.useQuery(
			{ where: { prescriptionId: prescription?.id, active: true } },
			{ enabled: !!prescription?.id },
		)

	const isLoading = patientLoading || practitionerLoading || prescriptionLoading || lpLoading
	const patientName = patient
		? `${patient.firstName} ${patient.lastName}`
		: null
	const practitionerId = practitioner?.id ?? ""

	return (
		<Page>
			<Container width="xl" padding="lg" gap="lg">
				<PageHeader
					title={patientName ? `Cannabis Prescription — ${patientName}` : "Cannabis Prescription"}
				/>

				{isLoading ? (
					<Placeholder title="Loading patient data..." />
				) : (
					<Card>
						<CardHeader>
							<div className="flex items-center justify-between">
								<div>
									<CardTitle>{patientName ?? "Patient"}</CardTitle>
									{patient?.dateOfBirth && (
										<CardDescription>
											DOB: {new Date(patient.dateOfBirth).toLocaleDateString()}
										</CardDescription>
									)}
								</div>
								{prescription ? (
									<Badge variant="secondary">Active Prescription</Badge>
								) : (
									<Badge>New Prescription</Badge>
								)}
							</div>
						</CardHeader>
						<CardContent>
							<PrescriptionForm
								patientId={patientId}
								practitionerId={practitionerId}
								prescription={prescription ?? undefined}
								existingLpPrescriptions={existingLpPrescriptions ?? undefined}
							/>
						</CardContent>
					</Card>
				)}
			</Container>
		</Page>
	)
}
